// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7fec8a77","806":"cc018124"}[chunkId] + ".chunk.js";
};